function copy(value, context) {
  if (value == null)
    return value;
  return value.map((override) => ({ ...override, value: copyBorderValue(override.value) }));
  function copyBorderValue({ borderTop, borderRight, borderBottom, borderLeft }) {
    return {
      borderTop: borderTop && copyBorderSide(borderTop),
      borderRight: borderRight && copyBorderSide(borderRight),
      borderBottom: borderBottom && copyBorderSide(borderBottom),
      borderLeft: borderLeft && copyBorderSide(borderLeft)
    };
  }
  function copyBorderSide(borderSide) {
    const { color } = borderSide;
    if (color == null)
      return borderSide;
    return {
      ...borderSide,
      color: {
        ...color,
        swatchId: context.replacementContext.swatchIds.get(color.swatchId) ?? color.swatchId
      }
    };
  }
}
export {
  copy
};
//# sourceMappingURL=border.js.map